import { render, staticRenderFns } from "./Forgot.vue?vue&type=template&id=4ea22e94&"
import script from "./Forgot.vue?vue&type=script&lang=ts&"
export * from "./Forgot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports